import { countBy } from 'lodash';
import * as React from 'react';

import { IStore } from '../../types';
import { ISlotItemPort } from '../../types/store/slotsItems';
import { getAvailablePoeBudget } from '../../utils/manageBudgetSlots';

interface ISlotStatsProps {
  item: ISlotItemPort;
  qty: number;
}

const SlotStats = (props: ISlotStatsProps) => (
  <div className="total-item port-item">
    {`${props.item.simpleNameLabel} ports: `}
    <span>{props.qty * props.item.portsBySlot}</span>
  </div>
);

const Stats = (props: IStore) => {
  const allPortsItemsBudgetCount = countBy(props.budget.slots.front.slotsSpecs, 'filled');

  const total10GPorts = Object.keys(allPortsItemsBudgetCount)
    .filter(itemId => (props.slotsItems[itemId] as ISlotItemPort).gsByPort === 10)
    .reduce(
      (total, itemId) =>
        (total += allPortsItemsBudgetCount[itemId] * (props.slotsItems[itemId] as ISlotItemPort).portsBySlot),
      0
    );
  return (
    <div className="col-md-12 col-xxl-12 sections switch-details">
      <h3 className="section-title">Key Metrics</h3>
      {props.routerData.portsSupported.map((slotId: string) => (
        <SlotStats
          key={`slot-stat-${slotId}`}
          item={props.slotsItems[slotId] as ISlotItemPort}
          qty={allPortsItemsBudgetCount[slotId] ? allPortsItemsBudgetCount[slotId] : 0}
        />
      ))}

      <div className="total-item total-ports port-item">
        Total number of 10G ports: <span>{total10GPorts}</span>
      </div>
      <div className="total-item poe-budget f">
        Available PoE budget @110VAC :{' '}
        <span>{`${getAvailablePoeBudget(
          'VAC110',
          props.routerData,
          props.slotsItems,
          props.budget,
          props.availablePower
        )} Watts`}</span>
      </div>
      <div className="total-item poe-budget s">
        Available PoE budget @220VAC :{' '}
        <span>{`${getAvailablePoeBudget(
          'VAC220',
          props.routerData,
          props.slotsItems,
          props.budget,
          props.availablePower
        )} Watts`}</span>
      </div>
    </div>
  );
};

export default Stats;



// WEBPACK FOOTER //
// ./src/components/Configurator/Stats.tsx